import { PositionEmploymentStatus } from 'src/api';

export const POSITION_EMPLOYMENT_STATUS_LABEL: Record<
  PositionEmploymentStatus | 'Unknown',
  string
> = {
  [PositionEmploymentStatus.Active]: 'Active',
  [PositionEmploymentStatus.Deceased]: 'Deceased',
  [PositionEmploymentStatus.Fmla]: 'FMLA',
  [PositionEmploymentStatus.Ifmla]: 'IFMLA',
  [PositionEmploymentStatus.Inactive]: 'Inactive',
  [PositionEmploymentStatus.Intern]: 'Intern',
  [PositionEmploymentStatus.OnLeave]: 'On Leave',
  [PositionEmploymentStatus.Retired]: 'Retired',
  [PositionEmploymentStatus.Separated]: 'Separated',
  [PositionEmploymentStatus.SeveredWithPay]: 'Severed With Pay',
  [PositionEmploymentStatus.TemporarilyInactive]: 'Temporarily Inactive',
  [PositionEmploymentStatus.Terminated]: 'Terminated',
  Unknown: 'Unknown',
};
